<script setup>
// Grant 2026-11-03 ("if you are a member of a club that offers playing area bookings it should show on your home
// timeline/screen quite prominently, with the appropriate Book court, Book court or board"): Home's Book entry, under
// Your clubs and above Your competitions. One booking club: ONE big primary button that says what can be booked
// ("Book a court", "Book a court or board": the feed's bookLabel, the API's own words, never a hard-coded noun). Two or
// more: a Book card with one row per club (its label, the club's name), no pick step. Nothing when no club of theirs
// takes bookings for players (the feed sends no bookLabel: bookings off, admin-only and not-yet-live setups alike).
import {computed} from 'vue';
import ClickableCell from '~/components/lists/ClickableCell.vue';
import {BOOKING_ICON} from '~/utils/bookingsMember';

const props = defineProps({
  /** The feed's managedClubs: every club the user belongs to, each with its bookLabel when it takes bookings. */
  clubs: {type: Array, default: () => []},
});

const bookingClubs = (clubs) => (clubs ?? []).filter((c) => !!c?.bookLabel);
const clubsToBook = computed(() => bookingClubs(props.clubs));
const bookTo = (club) => ({name: 'ClubBook', params: {clubId: club.id}});
</script>

<template>
  <template v-if="clubsToBook.length === 1">
    <v-btn
        block color="primary" rounded="pill" size="large" class="text-none hbe-one mb-4"
        :prepend-icon="BOOKING_ICON" :to="bookTo(clubsToBook[0])"
        :data-testid="`home-book-${clubsToBook[0].id}`">
      {{ clubsToBook[0].bookLabel }}
    </v-btn>
  </template>
  <template v-else-if="clubsToBook.length > 1">
    <div class="tl-section-head"><h2>Book</h2></div>
    <clickable-cell
        v-for="club in clubsToBook" :key="club.id"
        tone="neutral" :icon="BOOKING_ICON" :title="club.bookLabel" :subtitle="club.name"
        :to="bookTo(club)" :data-testid="`home-book-${club.id}`"
    />
  </template>
</template>

<style scoped lang="scss">
/* the one big verb: the kit's primary pill at its full height, the words never shrunk */
.hbe-one { font-weight: 700; letter-spacing: 0; }
</style>
